import React, { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import "./Navigation.scss";
import Socials from "../Socials/Socials";
import SubNav from "../Subnav/Subnav";
import { isTablet } from "react-device-detect";
// assets
import logo from "../../assets/icons/logo.svg";
import logo_mobile from "../../assets/icons/logo--mobile.svg";
import icon_favourite from "../../assets/icons/icon-favorite.svg";
import icon_logout from "../../assets/icons/icon-logout.svg";
//data
import routes from "../../routes";
import { useLessonContext } from "../../context/providers/LessonContext";
import cogoToast from "cogo-toast";

export default function Navigation(props) {
	const { countLessons, lessonTotal, tipsTotal, pronunciationTotal } = useLessonContext();
	const user = JSON.parse(localStorage.getItem("user"));
	React.useEffect(() => {
		countLessons();
		findCurrentRouteObject();
		if(user.registerCompleted===false) {
			cogoToast.warn("Please confirm your email to access lesson", {
				...options,
				heading: "Warning ",
			});
		
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
	//console.log(props.match.path);

	const options = {
		hideAfter: 10,
		position: "top-center",
	};

	const findCurrentRouteObject = () => {
		let obj = routes.find((item) => item.pageLink === props.match.path);
		if (obj) {
			return obj.pageLabel;
		} else {
			return "Menu";
		}
	};

	const menuItems = routes.map((item, index) => {
		if (item.ifSubnav) {
			return (
				<div className="nav__item--with-subnav nav__item h-100 p-0 position-static" key={index}>
					{isTablet ? (
						<div className={`nav__item d-flex align-items-center w-100 h-100`} data-name={`${item.pageName}`}>
							{item.pageName}
						</div>
					) : (
						<NavLink
							className={`nav__item d-flex align-items-center w-100 h-100`}
							to={`${item.pageLink}`}
							data-name={`${item.pageName}`}
							exact
						>
							{item.pageName}
						</NavLink>
					)}
					<div className="nav__subnav d-none d-xl-flex justify-content-center">
						<SubNav
							item={{
								name: "Lessons",
								amountVideo: lessonTotal !== null && lessonTotal,
								path: "/lessons",
							}}
						/>
						<SubNav
							item={{
								name: "Pronunciations",
								amountVideo: pronunciationTotal !== null && pronunciationTotal,
								path: "/pronunciations",
							}}
						/>
						<SubNav
							item={{
								name: "Tips",
								amountVideo: tipsTotal !== null && tipsTotal,
								path: "/tips",
							}}
						/>
					</div>
				</div>
			);
		} else {
			return (
				<NavLink
					className={`nav__item d-flex align-items-center ${item.class ? item.class : ""}`}
					to={`${item.pageLink}`}
					data-name={`${item.pageName}`}
					key={index}
					onClick={() => setisMobileNavToggle(false)}
				>
					{item.pageName}
				</NavLink>
			);
		}
	});

	const targetElement = document.querySelector(".nav__container--mobile");

	const [isMobileNavToggle, setisMobileNavToggle] = useState(false);
	const logoutRedirection = `${process.env.REACT_APP_ACADEMY_SERVER}/logout`;
	//Call auth context
	//const { logout } = useAuthContext();
	const handleLogout = (e) => {
		e.preventDefault();
		//console.log(logoutRedirection);
		localStorage.clear();
		window.location = logoutRedirection;
		/*logout();
		
		;*/
	};

	isMobileNavToggle ? disableBodyScroll(targetElement) : enableBodyScroll(targetElement);
	return (
		<div className={"nav__container " + (isMobileNavToggle ? "mobilenav_is_opened" : "mobilenav_is_closed")}>
			<div className="container d-flex justify-content-between justify-content-xl-start">
				<div className="d-flex align-items-center">
					<Link to="/" className="nav__logo">
						<img src={logo_mobile} alt="Kodjoe academy logo" className="h-100 d-xl-none" />
						<img src={logo} alt="Kodjoe academy logo" className="h-100 d-none d-xl-block" />
					</Link>
					<p className="nav__pagename d-xl-none">{findCurrentRouteObject()}</p>
				</div>
				{isTablet && (
					<nav className="nav--tablet d-flex flex-row align-items-stretch justify-content-center w-100 d-xl-none">
						<NavLink className={`nav__item d-flex align-items-center h-100`} data-name="Lessons" to="/lessons/">
							Lessons
						</NavLink>
						<NavLink
							className={`nav__item d-flex align-items-center h-100`}
							data-name="Pronunciations"
							to="/pronunciations/"
						>
							Pronunciations
						</NavLink>
						<NavLink className={`nav__item d-flex align-items-center h-100`} data-name="Tips" to="/tips/">
							Tips
						</NavLink>
					</nav>
				)}
				<div className="nav__container--mobile flex-column justify-content-between align-items-center d-xl-flex flex-xl-row flex-xl-grow-1">
					<div className="d-xl-none"></div>
					<nav className="nav d-flex flex-column align-items-center w-100 flex-xl-row">{menuItems}</nav>
					<div className="d-flex flex-column align-items-center flex-shrink-0 flex-xl-row">
						<span
							className="nav__item nav__item--logout d-flex align-items-center"
							data-name={user.firstName + " " + user.lastName}

							//to={logoutRedirection}
						>
							{user.firstName + " " + user.lastName}
						</span>
						<span style={{ cursor: "pointer" }} onClick={(e) => handleLogout(e)} >
							<img src={icon_logout} height="45px" alt="Logout"/>
						</span>
						<NavLink
							className="nav__item nav__item--help d-flex align-items-center"
							data-name="Need help ?"
							to="/support"
						>
							Need help ?
						</NavLink>

						<Socials class={"d-xl-none"}></Socials>
					</div>
				</div>
				<div className="d-flex flex-shrink-0 align-content-center align-items-center d-xl-none">
					<NavLink className="nav__item nav__item--favorite" to="/favorites">
						<img src={icon_favourite} alt="Favourite icon" />
					</NavLink>
					<div className="nav__hamburger" onClick={() => setisMobileNavToggle(!isMobileNavToggle)}>
						<span></span>
						<span></span>
						<span></span>
					</div>
				</div>
			</div>
		</div>
	);
}
